/* eslint-disable no-bitwise */
import { store } from 'container';
import { createBrowserHistory } from 'history';
import { useLayoutEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import engKiny from 'constants/language';

export const history = createBrowserHistory();

export const useWindowSize = () => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  useLayoutEffect(() => {
    const updateSize = () => {
      const { innerWidth: width, innerHeight: height } = window;
      setSize({ width, height });
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};

export const numberDelimiter = number => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const genNumber = (length = 1, upper = 256) =>
  Array.from({ length }, () => Math.floor(Math.random() * upper));

const toHEX = ([red = 255, green = 255, blue = 255]) =>
  `#${((red << 16) + (green << 8) + blue).toString(16).padStart(6, '0')}`;

const toRGBA = ([red = 255, green = 255, blue = 255], opacity = 1) =>
  `rgba(${red}, ${green}, ${blue}, ${opacity})`;

const calcTint = (value, index = 0.0001) => Math.round(value + (255 - value) * index);

const calcShade = (value, index = 0.4) => Math.round(value * index);

export const genColor = (type = 'solo', format = 'hex', opacity = 1) => {
  // type can be oneOf(['solo' || 'tint' || 'shade' || 'soloTint' || 'soloShade' || 'tintShade' || 'all'])
  // format can oneOf(['hex', 'rgba'])
  // opacity can be oneOf([number, array[numbers]])
  const [red, green, blue] = genNumber(3); // 0 - 255

  const formatFn = (array, darkness) =>
    format === 'rgba' ? toRGBA(array, darkness) : toHEX(array);

  const solo = [red, green, blue];
  const tint = [calcTint(red), calcTint(green), calcTint(blue)];
  const shade = [calcShade(red), calcShade(green), calcShade(blue)];
  let solOP, tintOP, shadeOP;
  if (typeof opacity === 'number') {
    solOP = opacity;
    tintOP = opacity;
    shadeOP = opacity;
  } else if (typeof opacity === 'object' && opacity.length) {
    [solOP, tintOP, shadeOP] = opacity;
  }

  switch (type) {
    case 'solo':
      return formatFn(solo, solOP);
    case 'tint':
      return formatFn(tint, tintOP);
    case 'shade':
      return formatFn(shade, shadeOP);
    case 'soloTint':
      return [formatFn(solo, solOP), formatFn(tint, tintOP)];
    case 'soloShade':
      return [formatFn(solo, solOP), formatFn(shade, shadeOP)];
    case 'tintShade':
      return [formatFn(tint, tintOP), formatFn(shade, shadeOP)];
    case 'all':
      return [formatFn(solo, solOP), formatFn(tint, tintOP), formatFn(shade, shadeOP)];
    default:
      return formatFn(solo, solOP);
  }
};


export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.readAsDataURL(img);
  reader.onloadend = callback;
};

export const getToken = () => {
  return localStorage.getItem('accessToken');
};
export const getLang = () => {
  return localStorage.getItem('s_lng');
};
export const setLang = lng => {
  localStorage.setItem('s_lng', lng);
};

export const setToken = token => {
  return localStorage.setItem('accessToken', token);
};

export const isLoggedIn = () => {
  const token = getToken();
  const currentDate = new Date();
  if (token) {
    const decodedToken = decodeToken();
    if (decodedToken) {
      // JWT exp is in seconds
      if (decodedToken.exp * 1000 < currentDate.getTime()) {
        localStorage.clear();
        localStorage.removeItem('userToken');
        return false;
      }
    }
    return !!decodedToken;
  }
  return false;
};

export const decodeToken = () => {
  const token = localStorage.getItem('accessToken');
  if (token !== null) {
    return jwtDecode(token);
  }
  return false;
};

/** Get month from date
 *
 * @param date
 * @param current
 * @returns {*}
 */
export function getStringMonthFromDate(date, current = 0) {
  const inputDate = new Date(date);
  const startYear = inputDate.getFullYear();
  const startMonth = inputDate.getMonth();
  const months = [];
  for (let month = 0; month < startMonth + 12; month++) {
    const currentYear = Math.floor((startMonth + month) / 12) + startYear;
    const currentMonth = (startMonth + month) % 12;
    const currentDate = new Date(currentYear, currentMonth, 1);
    const monthName = currentDate.toLocaleString('en-US', {month: 'long'});
    months.push(`${monthName} ${currentYear}`);
  }
  return months[current];
}

export function isDueDate(subscription = ""){
  const dueDate = new Date(subscription);
  const currentDate = new Date();
  // Check if today is the due date
  return currentDate >= dueDate;
}
